import { render, staticRenderFns } from "./SwiperProgress.vue?vue&type=template&id=680b08b2&"
import script from "./SwiperProgress.vue?vue&type=script&lang=js&"
export * from "./SwiperProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports